import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { init, pageview, attachJivoHooks } from "./index";

/*
  Живёт под BrowserRouter рядом с ThemeProvider. Делает две вещи:
  инициализирует аналитику один раз и шлёт pageview на SPA-переходах.

  Pageview считается по pathname + search. Смена только hash (#tarifs,
  #iptv и прочие якоря меню) — это не переход на новую страницу, события
  для неё не шлём.
*/
const AnalyticsRoutes = () => {
  const { pathname, search } = useLocation();
  const last = useRef(null);

  useEffect(() => {
    // колбэк Jivo вешаем сразу: виджет грузится отложенно и читает
    // window.jivo_onOpen при старте, позже присваивать уже поздно
    attachJivoHooks();
  }, []);

  useEffect(() => {
    // init смотрит текущий роут сам: на /login, /admin* и /notNetwork он
    // ничего не поднимает
    init(pathname);
    const path = pathname + (search || "");
    if (last.current === path) return;
    last.current = path;
    pageview(path);
  }, [pathname, search]);

  return null;
};

export default AnalyticsRoutes;
